import React, { useState, useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';
import SecureStore from "react-secure-storage";

import { motion } from "framer-motion";

import images from '../libs/images';
import consts from '../libs/consts';

import { useLang, usePopup } from "../zustand/store.js";

import { animateCSS } from "../utils/utils";

import Image from './Image';

export default function Language() {

    const location = useLocation();

    const ref = useRef();

    const { country, setLang } = useLang();
    const { langPop, toggleLangPop } = usePopup();

    useEffect(() => {

        if(langPop) toggleLangPop();
        
    }, [location.pathname]);

    useEffect(()=> {
        const handleOutsideClose = (e) => {
            if(langPop && (!ref?.current?.contains(e.target))) toggleLangPop();
        };

        document.addEventListener('click', handleOutsideClose);
        
        return () => document.removeEventListener('click', handleOutsideClose);

    }, [langPop]);
     

    const clickFunc = (v) => {

        SecureStore.setItem('country', v);
        setLang({key: 'country', value: v});

        toggleLangPop();
    }

    return (
        <motion.div
            ref={ref} 
            className='header_pop'
            initial={consts.loaderVariants.open}
        >
            <Image className={['language']} src={images.language} onClick={toggleLangPop}/>

            <motion.div 
                className='header_pop_box language_list'
                initial={consts.headerVariants.closed}
                animate={langPop ? "open" : "closed"}
                variants={consts.headerVariants}
            >
                <p className={country === 'ko' ? 'active' : ''} onClick={() => clickFunc('ko')}>한국어</p>
                <p className={country === 'en' ? 'active' : ''} onClick={() => clickFunc('en')}>English</p>
            </motion.div>
        </motion.div>
    )    
}